// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"45d12fc5","190":"446a19b2","612":"446a19b2","1392":"eb268864","2724":"446a19b2","4421":"e9b1362f"}[chunkId] + ".chunk.css";
};